export default __webpack_public_path__ + "static/media/PagerDuty.dcad4667.svg";